// src/api/axiosInstance.js
import axios from "axios";
import * as Sentry from "@sentry/react";
import { isBinnenkortAntwoord, koppelAanAxios } from "../lib/testmodus";

const axiosInstance = axios.create({
  timeout: 15000,
});

// ─── Request Interceptor ───────────────────────────────────────────
axiosInstance.interceptors.request.use(
  (config) => {
    // De parameters gingen hier mee en daar kan een gastnummer of een sleutel in zitten. Het adres
    // en de methode zijn genoeg om te zien wat er gebeurde. (WI7)
    Sentry.addBreadcrumb({
      category: "http.request",
      message: `${config.method?.toUpperCase()} ${config.url}`,
      data: {
        url: config.url,
        method: config.method,
      },
      level: "info",
    });
    return config;
  },
  (error) => {
    Sentry.captureException(error);
    return Promise.reject(error);
  }
);

// ─── Response Interceptor ──────────────────────────────────────────
axiosInstance.interceptors.response.use(
  (response) => {
    Sentry.addBreadcrumb({
      category: "http.response",
      message: `${response.status} ${response.config?.url}`,
      data: {
        status: response.status,
        url: response.config?.url,
      },
      level: "info",
    });
    return response;
  },
  (error) => {
    const { response, config } = error;

    // Een winkel in de testfase is geen fout: de widget toont "Binnenkort beschikbaar". (Mollie blok 2)
    if (isBinnenkortAntwoord(response)) return Promise.reject(error);

    Sentry.withScope((scope) => {
      scope.setTag("api.url", config?.url);
      scope.setTag("api.method", config?.method);
      scope.setTag("api.status", response?.status);
      // Hier gingen responseData en requestParams mee. In een boekwidget zit daar de naam, het
      // e-mailadres, het telefoonnummer en de inhoud van de reservering in -- dat hoort niet in
      // een foutmelding. Wat blijft: waar het misging, hoe, en wat de server ervan vond. Daar los
      // je een fout mee op. (WI7, 13-09-2026)
      scope.setContext("API Error", {
        url: config?.url,
        method: config?.method,
        status: response?.status,
        statusText: response?.statusText,
      });

      if (response?.status >= 500) scope.setLevel("error");
      else if (response?.status >= 400) scope.setLevel("warning");

      Sentry.captureException(error);
    });

    return Promise.reject(error);
  }
);

// Het teken van de voorbeeldlink mee, en "binnenkort" van de api naar het scherm. (Mollie blok 2)
koppelAanAxios(axiosInstance);

export default axiosInstance;   // ✅ must be default export